import { IResponse } from './helper.interface';

interface IClientID {
  id: string;
}
export interface IClientCreateResponse {
  client: IClientID;
}

export type IClientUpdateResponse = IResponse
